import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  TemplateRef,
  ViewChild
} from "@angular/core";

export interface ActionBarAction {
  icon?: string,
  label: string,
  action?: Function,
  disabled?: Function,
  helpText?: string,
  disabledText?: string,
  templateRef?: TemplateRef<any>
}

@Component({
  selector: 'vb-action-bar',
  templateUrl: './action-bar.component.html',
  styleUrls: ['./action-bar.component.css']
})
export class ActionBarComponent implements OnInit, AfterViewInit {

  @ViewChild('contentContainer')
  contentContainer: ElementRef;

  @ViewChild('filterMenu')
  filterMenuRef: ElementRef;

  @Input()
  actions: ActionBarAction[];

  @Input()
  showFilters: boolean = true;

  filterOpen = false;

  constructor(private cd: ChangeDetectorRef) {
  }

  ngOnInit() {

  }

  toggleFilterMenu() {
    if (this.filterOpen) {
      this.closeFilterMenu();
    } else {
      this.openFilterMenu()
    }
  }

  closeFilterMenu() {
    this.filterOpen = false;
    this.filterMenuRef.nativeElement.classList.remove('open');
  }

  openFilterMenu() {
    this.filterOpen = true;
    this.filterMenuRef.nativeElement.classList.add('open');
  }

  ngAfterViewInit(): void {
    this.showFilters = (this.showFilters && this.contentContainer.nativeElement.children.length > 0);
    this.cd.detectChanges();
  }

  onActionClicked(action: ActionBarAction) {
    if (action.disabled && action.disabled()) {
      return;
    }

    if (!action.action) {
      return;
    }

    action.action();
  }

  getActionHelpText(action: ActionBarAction) {

    if (action.disabled && action.disabled() && action.disabledText) {
      return action.disabledText;
    }

    return action.helpText ? action.helpText : '';
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/navigation/action-bar/action-bar.component.ts